module.exports = __webpack_public_path__ + "PTC.png?1a6ba1635305775aad59623f44b4b33e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PTC.png
// module id = 14
// module chunks = 0